export const notificationsModalParams = {
  position: { left: '0', top: 'var(--header-height)', bottom: '0' },
  height: 'calc(100% - var(--header-height))',
  backdropClass: 'notification-modal-backdrop',
  panelClass: 'notification-modal-panel',
  width: '48.375rem',
  maxWidth: '100%',
  autoFocus: false,
  overflow: 'auto'
};
